import { Route, Routes } from 'react-router-dom';
import Home from '@/pages/Home';
import InnovativeTechnologySolutions from '@/pages/InnovativeTechnologySolutions';
import SoftwareDevelopmentService from '@/pages/SoftwareDevelopmentService';
import EnterpriseSolutionsCloudITServices from '@/pages/EnterpriseSolutionsCloudITServices';
import TradingSystemSolutions from '@/pages/TradingSystemSolutions';
import CoreServices from '@/pages/CoreServices';
import ClientApplicationAreas from '@/pages/ClientApplicationAreas';
import CompanyInformation from '@/pages/CompanyInformation';
import LayoutMain from '@/layouts/LayoutMain';
import { ERoutePath } from '@/constants/route';

export const PublicRoutes = () => {
  return (
    <Routes>
      <Route element={<LayoutMain />}>
        <Route path={ERoutePath.HOME} element={<Home />} />
        <Route
          path={ERoutePath.SOFTWARE_DEVELOPMENT_SERVICE}
          element={<SoftwareDevelopmentService />}
        />
        <Route
          path={ERoutePath.INNOVATIVE_TECHNOLOGY_SOLUTION}
          element={<InnovativeTechnologySolutions />}
        />
        <Route
          path={ERoutePath.ENTERPRISE_SOLUTIONS_CLOUD_IT_SERVICES}
          element={<EnterpriseSolutionsCloudITServices />}
        />
        <Route path={ERoutePath.TRADING_SYSTEM_SOLUTIONS} element={<TradingSystemSolutions />} />
        <Route path={ERoutePath.CLIENT_APPLICATION_AREAS} element={<ClientApplicationAreas />} />
        <Route path={ERoutePath.CORE_SERVICES} element={<CoreServices />} />
        <Route path={ERoutePath.COMPANY_INFORMATION} element={<CompanyInformation />} />
      </Route>
    </Routes>
  );
};
